import { cn } from '@resolute/ui';
import { Link } from 'react-router-dom';


// Served from apps/web/public — referenced by root URL (not imported).
// The original navy lockup on a transparent background — no plate behind the mark.
const logoSrc = '/resolute-logo.webp';

export interface LogoProps {
  className?: string;
  /** Tailwind height class for the mark (width scales to preserve ratio). */
  sizeClassName?: string;
}

/**
 * Official Resolute Property Solutions logo. The artwork is never recreated —
 * we ship the transparent lockup as-is, re-encoded to WebP for a smaller payload.
 */
export function Logo({ className, sizeClassName = 'h-9 sm:h-10' }: LogoProps) {
  return (
    <Link
      to="/"
      className={cn('inline-flex items-center', className)}
      aria-label="Resolute Property Solutions — home"
    >
      <img
        src={logoSrc}
        alt=""
        width={207}
        height={55}
        decoding="async"
        className={cn('w-auto select-none', sizeClassName)}
      />
    </Link>
  );
}
